import AppLocales from '../locales/app.locales.json'
import ChartLocales from '../locales/charts.locales.json'

export enum LANGUAGES {
  FR = 'fr', EN = 'en'
}

export enum LOCALES {
  FR = 'fr-FR',
  EN = 'en-EN'
}

/** Robust check: /fr as path segment (avoids false positives like /fraternite) */
export const isFrenchPath = (): boolean => {
  if (typeof window === 'undefined') return false
  const path = window.location.pathname
  return path.includes('/fr/') || path === '/fr'
}

/** Returns the alternate locale URL for the language switcher (Webflow Localize: default at root, French at /fr/) */
export const getAlternateLocaleUrl = (): string => {
  const path = window.location.pathname
  const base = window.location.origin
  const search = window.location.search
  const hash = window.location.hash

  if (isFrenchPath()) {
    // French -> English: remove /fr prefix
    const rest = path === '/fr' ? '' : path.slice(4) || '/'
    return `${base}${rest || '/'}${search}${hash}`
  } else {
    // English -> French: add /fr prefix
    const rest = path === '/' ? '' : path
    return `${base}/fr${rest}${search}${hash}`
  }
}

class I18n {
  readonly locales: any
  language: LANGUAGES
  constructor() {
    this.language = this.getLanguage()
    const Locales = {
      fr: { ...AppLocales.fr, ...ChartLocales.fr },
      en: { ...AppLocales.en, ...ChartLocales.en }
    } as const
    this.locales = Locales[this.language]
  }

  getLanguage() {
    if (this.pageInEnglish()) { return LANGUAGES.EN }
    else { return LANGUAGES.FR }
  }

  pageInEnglish() {
    try {
      return !isFrenchPath()
    } catch (error) {
      console.warn('Error determining page Language:', error)
      return true
    }
  }

  t(entry: string) {
    const value = this.locales[entry]
    if (!value) {
      console.warn(`translation missing for ${entry} in ${this.language}`)
    }
    return value
  }

  getLocale(): LOCALES {
    const locale = this.getLanguage() === LANGUAGES.FR ? LOCALES.FR : LOCALES.EN
    return locale
  }

  parse(elem: HTMLElement, selector = 'i18n'): HTMLElement {
    const clonedContent = elem.cloneNode(true) as HTMLElement
    const nodes = clonedContent.querySelectorAll(`[${selector}]`)
    nodes.forEach(el => {
      const key = el.getAttribute(selector)
      if (key) el.textContent = this.t(key)
    })
    return clonedContent
  }
}

export const i18n = new I18n()